import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=9c8b8020&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=9c8b8020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8b8020",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c8b8020')) {
      api.createRecord('9c8b8020', component.options)
    } else {
      api.reload('9c8b8020', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=9c8b8020&scoped=true&", function () {
      api.rerender('9c8b8020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/WuyeZiyuanManager/pakinglotoa/detail.vue"
export default component.exports